import Modal from 'components/Modal';
import Typography from 'components/Typography';
import styles from '../CreatePurchaseOrderModal.module.scss';
import {MissingItem} from '../useCreatePurchaseOrder';
import Button from 'components/Button';
import {useState} from 'react';
import Select from 'components/Select';
import {TriangleAlertIcon} from '../icons';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  missingItems: MissingItem[];
  onConfirm: (autoCreateMissingItems: boolean) => void;
  isLoading: boolean;
  errorMessage?: string;
};

const OPTIONS = [
  {label: 'Yes, add missing items to the Pickup', value: 'true'},
  {label: 'No, I will add them manually', value: 'false'},
];

function MissingItemsConfirmModal({
  isOpen,
  onClose,
  missingItems,
  onConfirm,
  isLoading,
  errorMessage,
}: Props) {
  const [autoCreateMissingItems, setAutoCreateMissingItems] = useState(false);

  return (
    <Modal isOpen={isOpen} onClose={onClose} className={styles.list_wrapper}>
      <Typography variant="h2">Confirmation Required</Typography>
      <div className={styles.missing_items_container}>
        <div className={styles.error_message_container}>
          <TriangleAlertIcon color="red" width={20} height={20} />
          <Typography variant="p" className={styles.error_message}>
            {errorMessage}
          </Typography>
        </div>
        <Typography variant="p">The following items are missing:</Typography>
        <div className={styles.missing_items_list}>
          {missingItems.map((item) => (
            <Typography variant="p" key={item.drug_id}>
              * {item.drug_name} x {item?.required}
            </Typography>
          ))}
        </div>
        <Typography variant="p">
          Would you like to add missing items to the Pickup?
        </Typography>
        <Select
          className={styles.select}
          placeholder="Click To Select"
          options={OPTIONS}
          onChange={(item) => {
            setAutoCreateMissingItems(item?.value === 'true');
          }}
          value={
            OPTIONS.find(
              (option) => option.value === autoCreateMissingItems.toString()
            ) || null
          }
        />
      </div>
      <div className={styles.button_container}>
        <Button
          onClick={() => onConfirm(autoCreateMissingItems)}
          loading={isLoading}
        >
          Confirm
        </Button>
      </div>
    </Modal>
  );
}
export default MissingItemsConfirmModal;
